import React from "react";
// Action Block

// Default
import { Handle, Position } from "@xyflow/react";

// Mui
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

// React-icons
import { MdOutlineSaveAlt } from "react-icons/md";
import { IoReorderThree } from "react-icons/io5";
import { GoArrowUpRight } from "react-icons/go";
import { FaBolt } from "react-icons/fa";
import { MdOutlineInput } from "react-icons/md";
import { IoFilterSharp } from "react-icons/io5";
import { Box, IconButton } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import { UnifiedIcon } from "../Icon/UnifiedIcon";

const getIcon = (type: string) => {
  switch (type) {
    case "Save Client Attributes":
      return <UnifiedIcon icon={MdOutlineSaveAlt} />;
    case "Save Timeseries":
      return <UnifiedIcon icon={MdOutlineSaveAlt} />;
    case "Log RPC From Device":
      return <UnifiedIcon icon={IoReorderThree} />;
    case "Log Other":
      return <UnifiedIcon icon={IoReorderThree} />;
    case "RPC Call Request":
      return <UnifiedIcon icon={GoArrowUpRight} />;
    case "Device Profile Node":
      return <UnifiedIcon icon={FaBolt} />;
    case "Message Type Switch":
      return <UnifiedIcon icon={IoFilterSharp} />;
    case "Input":
      return <UnifiedIcon icon={MdOutlineInput} />;
    default:
      return null;
  }
};

const TextBlock = ({
  data,
  onEdit,
  onDelete,
}: {
  data: any;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  return (
    <Card
      className="rule-block-header"
      sx={{
        width: "auto",
        borderRadius: "8px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        overflow: "hidden",
        backgroundColor: data?.addInfo?.bgColor || "gray",
        padding: "10px",
        // border: "1px solid #555",
        color: "white",
      }}>
      <Stack direction={"row"} gap={"5px"} alignItems={"center"}>
        {data?.addInfo?.icon && (
          <span className="material-icons" style={{ fontSize: 18 }}>
            {data?.addInfo?.icon}
          </span>
        )}
        <Typography variant="body1" color={"white"}>
          {data?.ruleName}
        </Typography>

        <Box className="hover-buttons">
          <IconButton
            onClick={onEdit}
            sx={{
              color: "white",
              background: data?.addInfo?.bgColor || "gray",
              padding: "5px",
              "&:hover": {
                background: data?.addInfo?.bgColor || "gray",
              },
            }}>
            <Edit style={{ fontSize: 14 }} />
          </IconButton>
          <IconButton
            onClick={onDelete}
            sx={{
              color: "white",
              background: data?.addInfo?.bgColor || "gray",
              padding: "5px",
              "&:hover": {
                background: data?.addInfo?.bgColor || "gray",
              },
            }}>
            <Delete style={{ fontSize: 14 }} />
          </IconButton>
        </Box>
      </Stack>

      {/* Handles */}
      <Handle type="target" position={Position.Left} style={styles.handle} />
      <Handle type="source" position={Position.Right} style={styles.handle} />
    </Card>
  );
};

const styles = {
  handle: {
    width: "10px",
    height: "10px",
    background: "#555",
  },
};

export default TextBlock;
